
const state = {
  objDoc: null,
  docItem: null,
  docTipos: [],
  limitObj: null,
  listDoc: [],
  listDocLength: {},
  listDocTotal: 0
}
const mutations = {
  updateDocuments: (state, obj) => {
    state.limitObj = obj.limitObj
  },
  updateDocTipos: (state, obj) => {
    state.docTipos = obj
    state.docTipos.unshift({ id: '', descricao: 'selecione' })
  }
}
const actions = {
  async getDocument({ state }, item) {
    let _this = this
    let base_url = process.env.VUE_APP_API_URL
    state.docItem = item
    let obj = {
      url: base_url + '/api/proxy/download?docId=' + state.docItem.doc_id,
      query: {
        docId: state.docItem.doc_id
      }
    };
    let USER_TOKEN = obj.token ? obj.token : sessionStorage.getItem('token')
    let AuthStr = 'Bearer '.concat(USER_TOKEN)
    await new Promise(() => {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', obj.url, true);
      xhr.setRequestHeader('Authorization', AuthStr);
      xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8')
      xhr.responseType = 'blob'
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var filename = xhr.getResponseHeader("Content-Disposition").split('; ')[1].replace('filename=','').replaceAll('"','')
          var downloadUrl = (window.URL || window.webkitURL).createObjectURL(xhr.response)
          var a = document.createElement("a");
          a.href = downloadUrl
          a.target="_blank"
          a.download = filename
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(downloadUrl);
        }
      }
      xhr.onerror = error => {
        let paramModal = {}
        paramModal.message = 'Não foi possível baixar o arquivo, tente novamente mais tarde. Caso o problema persista, contancte o administrador do sistema.'
        paramModal.title = 'Ocorreu erro'
        paramModal.type = 'error'
        paramModal.callback = null
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          name: 'Cancelar',
          show: false
        }
        _this.commit('hideLoader')
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
        return error
      }
      xhr.send(JSON.stringify(obj.query));
    })
  },
  async getDocumentPost(_this, { Payload, acao, callback, modulo }) {
    let base_url = process.env.VUE_APP_API_URL
    let obj = {
      url: base_url + '/api/proxy/download',
      query: [
        {
          Modulo: modulo ?modulo :"Recebiveis",
          Acao: acao,
          Payload: {...Payload}
        },
      ],
    };
    let USER_TOKEN = obj.token ? obj.token : sessionStorage.getItem('token')
    let AuthStr = 'Bearer '.concat(USER_TOKEN)
    await new Promise(() => {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', obj.url, true);
      xhr.setRequestHeader('Authorization', AuthStr);
      xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8')
      xhr.responseType = 'blob'
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          var filename = xhr.getResponseHeader("Content-Disposition").split('; ')[1].replace('filename=','').replaceAll('"','')
          var downloadUrl = (window.URL || window.webkitURL).createObjectURL(xhr.response)
          var a = document.createElement("a")
          a.href = downloadUrl
          a.target="_blank"
          a.download = filename
          document.body.appendChild(a)
          a.click()
          URL.revokeObjectURL(downloadUrl)
          if(callback) {
            callback()
          }
        }
      }
      xhr.onerror = error => {
        let paramModal = {}
        paramModal.message = 'Não foi possível baixar o arquivo, tente novamente mais tarde. Caso o problema persista, contancte o administrador do sistema.'
        paramModal.title = 'Ocorreu erro'
        paramModal.type = 'error'
        paramModal.callback = null
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          name: 'Cancelar',
          show: false
        }
        _this.commit('hideLoader')
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
        return error
      }
      xhr.send(JSON.stringify(obj.query));
    })
  },
  async getDocuments({ state }, opts) {
    
    let geco = opts.grupoEconomico ? opts.grupoEconomico : this.state.permissions.grupoEconomico
    let offset = opts.offset != null && opts.offset > 0 ? opts.offset : 1;
    let obj = {
      query: [
        {
          Modulo: "Portal",
          Acao: "getdocuments",
          Payload: {
            prestador_id: opts.prestador,
            grupo_economico: geco,
            data_inicio: opts.data_inicio,
            data_fim: opts.data_fim,
            modulo: opts.modulo,
            tipo: opts.tipo,
            search: opts.search,
            limit: opts.limit,
            offset: offset
          },
        },
      ],
    };
    await this.dispatch("request/doRequest", obj).then(response => {
      // updateDocuments
      state.listDocLength = response.total_novos
      state.listDoc = response.dados
      state.listDocTotal = response.total
      return response.total
    });
  },
  async getDocTypes({ state }) {
    // return []
    let obj = {
      query: [
        {
          Modulo: "Portal",
          Acao: "gettiposdocumentos",
          Payload: {},
        },
      ],
    };
    await this.dispatch("request/doRequest", obj).then(response => {
      state.docTipos = response.dados;
    });

  }
}
export default {
  namespaced: true,
  root: true,
  actions,
  mutations,
  state,
};